<template>
  <div class="login-box">
    <div v-if="visible" class="login-page" :style="{'z-index': zIndex, 'background': bgImage}"></div>
    <JyDialog :visible.sync="visible" max-width="450px" :showClose="false" ref="loginDialog" :activatedLoad="init" :onOpen="loginOnOpen">
      <div slot="title" class="font125 font-weight-bold">
        师大党委组织部 / 系统登录
      </div>
      <!-- <div class="login-type" @click="toggleQrcode">
        <i v-if="isQrcode" key="type-password" class="fa fa-laptop" title="账号密码登录"></i>
        <i v-else key="type-weixin" class="fa fa-qrcode" title="微信扫码登录"></i>
      </div>
      <div v-show="isQrcode">
        <div class="d-flex flex-column">
          <p class="text-center"><img :src="qrcodeUrl" style="width:200px;"></p>
          <p class="text-muted text-center">用微信"扫一扫"登录</p>
          <p class="text-danger text-center">{{ qrcodeMsg }}</p>
        </div>
      </div> -->
      <el-form v-show="!isQrcode" :model="userinfo" :rules="rules" ref="userForm" :labelSize="0" @submit.native.prevent="loginSubmit">
        <el-row type="flex" class="flex-wrap">
          <form-item v-if="errmsg" fill="4" label-width="0" no-hover>
            <p class="text-danger text-center">{{ errmsg }}</p>
          </form-item>
          <form-item fill="4" label-width="0" prop="username" no-hover>
            <el-input v-model="userinfo.username" name="username" :rules="rules.username" placeholder="登录账号" prefix-icon="el-icon-user" size="lg" ref="username"></el-input>
          </form-item>
          <form-item fill="4" label-width="0" prop="password" no-hover>
            <el-input type="password" v-model="userinfo.password" name="password" :rules="rules.password" placeholder="登录密码" prefix-icon="el-icon-lock" size="lg"></el-input>
          </form-item>
          <form-item fill="4" label-width="0" prop="captcha" no-hover>
            <el-input type="captcha" v-model="userinfo.captcha" :rules="rules.password" placeholder="验证码" prefix-icon="el-icon-circle-check" size="lg"
              @keyup.enter="handleEnter" :suffixBtn="false" class="captcha">
              <span slot="suffix"><img :src="captcha" @click="getCaptcha()" title="点击刷新" height="35"></span>
            </el-input>
          </form-item>
        </el-row>
        <div class="login-btns mt-2 text-center">
          <JyButton type="primary" type-native="submit" icon="check-square-o" width="100%" size="lg" :isLoading="isLoading">登 录</JyButton>
        </div>
      </el-form>
    </JyDialog>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import * as types from 'jystore/mutation-types';
import tools from 'jyutils/tools';
export default {
  name: 'JyLogin',
  components: { },
  mixins: [tools],
  props: {

  },
  data() {
    return {
      isQrcode: false,
      visible: false,
      zIndex: 0,
      captcha: '',
      requiredLabel: false,
      isLoading: false,
      errmsg: '',
      qrcodeMsg: '',
      rules: {
        username: {required: true, message: '请填写登录账号！'},
        password: [{required: true, message: '请输入登录密码！'}],
        captcha: {required: true, message: '请输入验证码！'}
      },
    }
  },
  computed: {
    ...mapState(['userinfo', 'c_token']),
    ...mapGetters(['settingvue']),
    bgImage() {
      let num = Math.ceil(Math.random() * 6);
      return '#fff url('+ this.assetsPath +'static/images/bg_'+ num +'.jpg) no-repeat';
    },
    qrcodeUrl() {
      let token = this.$store.state.c_token;
      if (!token) {
        this.$store.dispatch(types.JY_TOKEN_GET);
      }
      return this.rootPath + 'sys/login/getQrcode?url='+ encodeURIComponent(this.$axios.defaults.wx_root +'sys/login/getQrUrl?token='+ this.$store.state.c_token) +'&t='+ (new Date().getTime());
    }
  },
  watch: {
    c_token() {
      this.getCaptcha();
    },
    visible(val) {
      if (val) {
        this.init();
      }
    }
  },
  mounted() {
  },
  methods: {
    show(flag) {
      this.visible = flag ? true : false;
    },
    init() {
      this.qrcodeMsg = '';
      this.getCaptcha();
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.username.$el.querySelector('input').focus();
          this.zIndex = this.$refs.loginDialog.$el.style.zIndex;
          if (this.zIndex) {
            this.zIndex --;
          }
        }, 150)
      });
    },
    getCaptcha() {
      this.$store.dispatch(types.JY_TOKEN_GET);
      this.captcha = this.rootPath + 'sys/login/getCaptcha?t='+ (new Date().getTime())
    },
    toggleQrcode() {
      this.isQrcode = !this.isQrcode;
      let token = this.$store.state.c_token;
      if (!token) {
        this.$store.dispatch(types.JY_TOKEN_GET);
      }
    },
    handleEnter() {
      //this.loginSubmit();
    },
    loginOnOpen() {
      // update zindex for top of other dialog
      this.$refs.loginDialog.$el.style.zIndex = 99999999;
    },
    loginSubmit() {
      this.submitform('userForm').then(() => {
        this.isLoading = true;
        this.errmsg = '';
        this.$store.dispatch(types.JY_LOGIN, (flag, msg, obj) => {
          if (!flag) {
            //this.$message.error(msg);
            this.errmsg = msg;
          } else {
            this.errmsg = '';
            this.$emit('login');
          }

          // check settingvue
          if (obj && obj.obj && obj.obj.settingvue) {
            if (!this.settingvue || this.settingvue.hashcode !== obj.obj.settingvue.hashcode) {
              this.$store.dispatch(types.JY_SETTINGVUE_SET, {settingvue: obj.obj.settingvue});
            }
          }

          if (obj) {
            if (obj.refreshCaptcha) {
              this.getCaptcha();
            } else if (obj.token) {
              this.$store.dispatch(types.JY_TOKEN_GET);
            }
          }

          this.isLoading = false;
        });
      })
      .catch(() => {
        
      });
    },
  }
}
</script>

<style>
.login-page{
  position:fixed; top:0; bottom:0; left:0; right:0; /*z-index:1000000;*/
  display:flex; justify-content:center; align-items:center;
  background-color:#fff; background-color:rgba(255,255,255,.95);
  background:#fff;
  background-repeat:no-repeat;
}
.login-box .jy-dialog{background-color:rgba(255,255,255,.8); box-shadow: 0 0 50px 0px rgba(0,0,0,.3);}
.login-type i{position:absolute; right:0.1rem; top:0.1rem; font-size:3rem; color:#fa5555; cursor:pointer; clip-path:polygon(0 0, 100% 0, 100% 100%, 90% 100%, 0 30%);}
.login-type i.fa-qrcode{right:.4rem;}
/* .login-type i.fa-desktop{font-size:2.8rem;} */
.login-box .input-group-lg > .input-group-append > .input-group-text{padding-top:0; padding-bottom:0;}
.login-box .captcha input{text-transform:uppercase;}
</style>
